import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const EditorialMarquee = ({ items, className = "", outline = false }) => (
  <div className={`border-y border-white/10 py-6 overflow-hidden ${className}`} data-testid="editorial-marquee">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span
            className={`font-sora font-bold uppercase tracking-tight text-3xl md:text-5xl px-6 ${
              outline ? "text-outline" : i % 2 === 0 ? "text-white/90" : "text-gradient"
            }`}
          >
            {item}
          </span>
          <Asterisk className="w-8 h-8 text-brand-purple shrink-0" strokeWidth={1.5} />
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
